module.exports = __webpack_public_path__ + "statics/img/ios.5322b441.png";